const scaleAndPositionObjects = (canvas: any, json: any) => {
  // get the workarea - the white background section of the template (the whole canvas)
  const workarea = json.objects.find((obj: any) => obj.id === "workarea") || {};
  if (workarea?.width) {
    const { width, height, scaleX, scaleY, left, top } = workarea;

    // update each object to fix the passed in size (update all objects to fit the new scale)
    canvas.forEachObject((obj: any, index: number) => {
      const canvasWidth = canvas.getWidth();
      const canvasHeight = canvas.getHeight();

      if (obj.id === "workarea") {
        // set work area to fix the whole output size
        obj.set({
          left: 0,
          top: 0,
          width: canvasWidth,
          height: canvasHeight,
          scaleX: 1,
          scaleY: 1,
        });
        obj.setCoords();
        return;
      }

      // the ratios of the workarea object compared to the whole canvas
      const leftRatio = canvasWidth / (width * scaleX);
      const topRatio = canvasHeight / (height * scaleY);

      const { left: objLeft, top: objTop, scaleX: objScaleX, scaleY: objScaleY } = obj;

      // the amount the workarea was moved to fit the scale of the whole canvas
      const workareaLeft = left * leftRatio;
      const workareaTop = top * topRatio;

      // update obj position and scale using the ratios we changed the workarea to fit the canvas
      const objData = {
        // for left and top - update to fit the new scale as well as adjust position the same amount we adjusted the workarea
        left: objLeft * leftRatio - workareaLeft,
        top: objTop * topRatio - workareaTop,
        scaleX: objScaleX * leftRatio,
        scaleY: objScaleY * topRatio,
      };

      obj.set(objData);
      obj.setCoords();
    });
  }

  canvas.renderAll();
};

export default scaleAndPositionObjects;
